import React, { PureComponent, Fragment } from 'react'
import styles from './History.scss'
import 'react-dates/initialize'
import { DateRangePicker } from 'react-dates'
import { Interpolate } from 'react-i18next'
import moment, { Moment } from 'moment'
import {
    Currency,
    Divider,
    StepCSSTransitionGroup,
    Spinner,
} from '@wg/wows-react-uikit'
import { TransactionStatus } from '../../UIKit/UIKit'
import { t, x } from '../../../helpers/localization'
import get from 'lodash/get'
import TotalBalance from '../TotalBalance/TotalBalance'
import { TRANSACTIONS_STATUSES } from '../../../Actions/ActionTreasury'

const BOTTOM_PADDING = 80

export type IMonth = Array<string>

export type History_Props = {
    isSpend: boolean,
    startDate: Moment,
    endDate: Moment,
    transactions: Array<any>,
    totalBalanceList: Balance,
    totalTransactionsSum: Balance,
    isTotalTransactionsSumUpdating: boolean,
    isTransactionListUpdating: boolean,
    isAppending: boolean,
    languageCode: string,
    formats: IDateFormats,

    appendTransactions: () => void,
    setFilterDates: (start: Moment, end: Moment) => void,
    showDistributionResultDialog: (transaction: Transaction) => void,
}

export type NewDates = {
    startDate: Moment,
    endDate: Moment,
}

export type Sum = {
    type: CurrencyType,
    sum: number
}

const ADMIN = 'Wargaming.net'

class History extends PureComponent<History_Props, any> {

    state = {}

    table = null

    sectionHeaders = {}

    activeHeader = null

    pointerEventsTimer: TimeoutID

    shadowTop = null

    shadowBottom = null

    month: IMonth = [
        t('Январь'),
        t('Февраль'),
        t('Март'),
        t('Апрель'),
        t('Май'),
        t('Июнь'),
        t('Июль'),
        t('Август'),
        t('Сентябрь'),
        t('Октябрь'),
        t('Ноябрь'),
        t('Декабрь'),
    ]

    componentDidMount() {
        window.addEventListener('resize', this.updateTableSize)
        this.updateTableSize()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateTableSize)
    }


    UNSAFE_componentWillReceiveProps(nextProps: History_Props) {
        if (this.props.isSpend !== nextProps.isSpend) {
            this.activeHeader = null
            this.sectionHeaders = {}
        }
    }

    setTableRef = (ref: any) => {
        if (ref) {
            this.table = ref
        }

    }

    updateTableShadows = () => {

        if (this.table) {

            const table = this.table

            const hasScroll = table.clientHeight < table.scrollHeight

            if (this.shadowBottom) {
                if (((table.scrollTop + table.clientHeight) >= table.scrollHeight) || !hasScroll) {
                    this.shadowBottom.style.opacity = '0'
                } else {
                    this.shadowBottom.style.opacity = '1'
                }
            }

            if (this.shadowTop) {
                if (table.scrollTop === 0) {
                    this.shadowTop.style.opacity = '0'
                } else {
                    this.shadowTop.style.opacity = '1'
                }
            }
        }

    }

    updateTableSize = () => {
        if (this.table) {
            const distanceFromTop = this.table.offsetTop
            const fullHeight = window.innerHeight - BOTTOM_PADDING
            const newTableHeight = fullHeight - distanceFromTop
            this.table.style.height = `${newTableHeight} px`
        }
    }

    getCurrencySum = (rowData: any): Sum => {

        let sum = 0
        let type = 'oil'

        if (rowData && rowData.data && rowData.data.receivers) {
            rowData.data.receivers.forEach((item, index) => {

                if (item.delta && item.player) {
                    if (rowData.data.offer) {
                        sum = item.delta.amount
                    } else {
                        sum = sum + item.delta.amount
                    }
                    type = item.delta.type
                } else {
                    sum = sum + item.amount.amount
                    type = item.amount.type
                }
            })
        }

        if (rowData && rowData.data && rowData.data.delta) {
            type = rowData.data.delta.type
            sum = rowData.data.delta.amount
        }

        return {
            sum,
            type,
        }
    }

    getDayAmount = (dayData: any) => {

        const res = []
        const resArray = []
        const sumByType: SumByType = {}

        if (dayData && dayData.transactions) {
            dayData.transactions.forEach((item) => {
                const sum = this.getCurrencySum(item)

                if (sumByType[sum.type] !== undefined) {
                    sumByType[sum.type] = sumByType[sum.type] + sum.sum
                } else {
                    sumByType[sum.type] = sum.sum
                }
            })
        }

        for (const key in sumByType) {
            if (sumByType.hasOwnProperty(key)) {
                let type = key
                let defType = (type === 'dublon') ? 'gold' : type
                const amount = sumByType[defType]
                resArray.push({
                    type,
                    amount,
                })
            }
        }

        resArray.sort((a, b) => Currency.order[b.type] - Currency.order[a.type]).forEach((item) => {
            res.push(
                <Currency
                    key={`DayAmount${item.type}`}
                    amount={item.amount}
                    isBold={true}
                    type={item.type}
                    t={t}
                />
            )
        })


        return res
    }

    getUserNames = (rowData: any) => {
        const names = rowData.data.receivers.map((item) => {
            return item.player.name
        }).join(', ')

        return (
            <span className={styles.inlineNames}>{`${names} `}</span>
        )
    }

    getCurrencyType = (rowData: any) => {

        if (rowData) {
            if (rowData.data.receivers) {
                const firstReceiver = get(rowData, ['data', 'receivers', 0], null)
                if (firstReceiver && firstReceiver.delta) {
                    return firstReceiver.delta.type
                }
            } else {
                return rowData.data.delta.type
            }
        }

        return 'oil'
    }

    renderDistributionTarget = (rowData: any) => {
        if (rowData.operation === 'rewards_distribution') {
            const reward = this.props.regularRewards.availableRewardOffers.filter(r => r.offer_id === rowData.data.offer)[0]
            const title = (reward && reward.title) ? reward.title : ''
            return (
                <span className={styles.rowTextDark}>
                    {`${title}`}
                </span>
            )
        } else if (rowData.data && rowData.data.receivers && rowData.data.receivers.length > 0) {

            if (rowData.data.receivers.length === 1) {
                const name = rowData.data.receivers[0].player.name
                return (
                    <Interpolate
                        useDangerouslySetInnerHTML={true}
                        i18nKey={x('%(title)s %(name)s')}
                        title={(
                            <span className={styles.rowTextDark}>
                                {t('Начисление игроку:')}
                            </span>
                        )}
                        name={(
                            <span className={styles.inlineNames}>{`${name} `}</span>
                        )}
                        parent={'div'}
                    />
                )
            } else {
                const delta = rowData.data.receivers[0].delta
                return (
                    <Interpolate
                        useDangerouslySetInnerHTML={true}
                        i18nKey={x('%(title)s %(amount)s %(players)s %(names)s')}
                        title={(
                            <span className={styles.rowTextDark}>
                                {t('Начисление по ')}
                            </span>
                        )}
                        amount={(
                            <Currency
                                withMargin
                                amount={delta.amount}
                                isBold={true}
                                type={delta.type}
                                t={t}
                            />
                        )}
                        players={(
                            <span className={styles.rowTextDark}>
                                {t(' игрокам: ')}
                            </span>
                        )}
                        names={this.getUserNames(rowData)}
                        parent={'div'}
                        className={styles.distributionCell}
                    />
                )
            }
        } else {
            return (
                <span className={styles.rowTextDark}>
                    {t('Распределение')}
                </span>
            )
        }

    }
    renderIncomeReason = (rowData: any) => {

        switch (rowData.operation) {
            case 'reimbursement': {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Возмещение ресурсов')}
                    </span>
                )
            }
            case 'generic_change': {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Изменение баланса')}
                    </span>
                )
            }
            case 'naval_battle_reward': {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Награда за морское сражение')}
                    </span>
                )
            }
            case 'clan_battles_reward': {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Награда за клановые бои')}
                    </span>
                )
            }
            case 'light_tournaments_reward': {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Награда за участие в потасовке')}
                    </span>
                )
            }
            case 'community_tournament_reward': {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Награда за прочие активности')}
                    </span>
                )
            }

            default: {
                return (
                    <span className={styles.rowTextDark}>
                        {t('Пополнение баланса')}
                    </span>
                )
            }
        }

    }

    getTransactionStatus = (rowData: any) => {

        if (rowData.status === TRANSACTIONS_STATUSES.COMPLETED) {
            if (rowData.data.failedReceivers && rowData.data.failedReceivers.length > 0) {
                return 'semiCompleted'
            } else {
                return rowData.status
            }
        } else {
            return rowData.status
        }
    }

    showTransactionData = (rowData: Transaction) => () => {
        if (this.props.isSpend) {
            this.props.showDistributionResultDialog(rowData)
        }
    }

    renderHistoryTable = () => {
        if (this.props.transactions.length === 0 && !this.props.isTransactionListUpdating) {
            return (
                <StepCSSTransitionGroup level={1}>
                    <div className={styles.noTransactionsWrapper}>
                        <span className={styles.noTransactionsTitle}>
                            {t('У вас еще нет ни одной транзакции')}
                        </span>
                    </div>
                </StepCSSTransitionGroup>
            )
        }

        if (this.props.isTransactionListUpdating) {
            return (
                <StepCSSTransitionGroup level={1}>
                    <div className={styles.noTransactionsWrapper}>
                        <Spinner label={t('Идет загрузка транзакций')} />
                    </div>
                </StepCSSTransitionGroup>
            )
        }

        return this.props.transactions.map((dayData, dayIndex) => {
            const sectionKey = `sectionKey${dayIndex} ${this.props.isSpend ? 'out' : 'in'} `
            return (
                <Fragment key={sectionKey}>
                    {(dayData.transactions.length > 0) ? (
                        <div
                            className={styles.StickyRow}
                            id={sectionKey}
                            ref={(ref) => {
                                if (ref) {
                                    this.sectionHeaders[sectionKey] = ref
                                }
                            }}
                        >
                            <div className={styles.innerRow}>
                                <div className={styles.cell}>
                                    <span className={`${styles.rowText} ${styles.boldText} `}>{moment.utc(dayData.date).format(this.props.formats.date)}</span>
                                </div>
                                {this.props.isSpend ? (
                                    <div className={`${styles.cell} ${styles.initiatorCell}`}>
                                        <span className={styles.opacityTitle}>{t('Исполнитель')}</span>
                                    </div>
                                ) : null}
                                <div className={styles.hugeCell}>
                                    <span className={styles.opacityTitle}>{this.props.isSpend ? t('Операция') : t('Поступления')}</span>
                                </div>
                                <div className={styles.spacer} />
                                <div className={styles.amountCell}>
                                    {this.getDayAmount(dayData)}
                                </div>
                            </div>
                        </div>
                    ) : null}

                    {dayData.transactions.map((rowData, rowIndex) => {
                        let transaction = rowData
                        if (rowData.childTransactions && rowData.childTransactions.length > 0) {
                            transaction = rowData.childTransactions[0]
                        }

                        const transactionStatus = this.getTransactionStatus(transaction)
                        const isFailed = transactionStatus === TRANSACTIONS_STATUSES.FAILED

                        return (
                            <Fragment key={`DayTransactions${rowIndex} `}>
                                <Divider type="major" />
                                <div key={`row${rowIndex} `} className={styles.row} style={isFailed ? { opacity: 0.7 } : {}} onClick={this.showTransactionData(rowData)}>
                                    <div className={styles.innerRow}>
                                        <div className={styles.inlineCell}>
                                            <TransactionStatus status={transactionStatus} operation={rowData.operation} />
                                            <span className={`${styles.rowText} `}>{moment.utc(rowData.date).local().format(this.props.formats.time)}</span>
                                        </div>
                                        {this.props.isSpend ? (
                                            <div className={`${styles.cell} ${styles.initiatorCell}`}>
                                                <span className={styles.rowText}>{rowData.initiator ? rowData.initiator.name : ADMIN}</span>
                                            </div>
                                        ) : null}
                                        <div className={styles.hugeCell}>
                                            {this.props.isSpend ? this.renderDistributionTarget(rowData) : this.renderIncomeReason(rowData)}
                                        </div>
                                        <div className={styles.spacer} />
                                        <div className={styles.amountCell}>
                                            <Currency
                                                amount={this.getCurrencySum(rowData).sum}
                                                isBold={true}
                                                type={this.getCurrencyType(rowData)}
                                                t={t}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )
                    })}
                </Fragment>
            )
        })
    }

    onDatesChange = ({ startDate, endDate }: NewDates) => {
        this.props.setFilterDates(startDate, endDate)
    }

    onClearFilter = ({ startDate, endDate }: NewDates) => {
    }

    renderMonthText = (month: any) => {
        const monthIndex = parseInt(month.format('M'), 10) - 1
        return this.month[monthIndex]
    }

    isOutsideRange = (day: any) => {
        return false
    }

    isDayBlocked = (day: any) => {
        if (day.diff(moment()) > 0) {
            return true
        }
        return false
    }

    renderCloseIcon = () => {
        return (
            <div className={styles.clearButton}>{t('Очистить')}</div>
        )
    }

    isDayHighlighted = (day: any) => {
        let isHighlighted = false
        const d = day.format('YYYY-MM-DD')

        this.props.transactions.forEach((transaction) => {
            if (d === moment(transaction.date).format('YYYY-MM-DD')) {
                isHighlighted = true
            }
        })

        return isHighlighted
    }

    tableScroll = (e: any) => {
        const table = e.nativeEvent.target

        clearTimeout(this.pointerEventsTimer)

        if (!table.classList.contains(styles.disableHover)) {
            table.classList.add(styles.disableHover)
        }

        this.pointerEventsTimer = setTimeout(() => {
            table.classList.remove(styles.disableHover)
        }, 300)

        if ((table.scrollTop + table.clientHeight) > (table.scrollHeight * 0.8) && !this.props.isAppending) {
            this.onScrollEnd()
        }


        for (const key in this.sectionHeaders) {
            if (this.sectionHeaders.hasOwnProperty(key)) {
                const sectionHeader = this.sectionHeaders[key]
                let translateY = table.scrollTop - sectionHeader.offsetTop - 1

                if (this.activeHeader && this.activeHeader.id !== sectionHeader.id) {
                    const activeHeaderOffset = translateY
                    const activeHeaderTransform = parseInt(this.activeHeader.style.transform.replace('translate(0px, ', '').replace('px)', ''))
                    if (activeHeaderOffset > -54) {
                        const substractOffset = 54 + activeHeaderOffset
                        const newTranslateY = activeHeaderTransform - substractOffset
                        if (this.activeHeader !== null) {
                            this.activeHeader.style.transform = `translate(0, ${newTranslateY}px)`
                        }
                    }
                }

                if (table.scrollTop > sectionHeader.offsetTop) {
                    sectionHeader.style.transform = `translate(0, ${translateY}px)`
                    this.activeHeader = sectionHeader
                } else {
                    sectionHeader.style.transform = 'translate(0,0)'
                }
            }
        }

        this.updateTableShadows()
    }

    onScrollEnd = () => {
        this.props.appendTransactions()
    }

    render() {
        this.updateTableShadows()
        return (
            <div className={styles.wrapper}>
                <div className={styles.tableHeader}>
                    <div className={styles.spendLabel}>
                        {this.props.isSpend ? t('Расходы за период:') : t('Доходы за период:')}
                    </div>
                    <DateRangePicker
                        startDate={this.props.startDate}
                        startDateId="filterPerionStart"
                        endDate={this.props.endDate}
                        endDateId="filterPerionEnd"
                        onDatesChange={this.onDatesChange}
                        onClose={this.onClearFilter}
                        focusedInput={this.state.focusedInput}
                        onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        showClearDates
                        small
                        numberOfMonths={1}
                        hideKeyboardShortcutsPanel
                        noBorder
                        startDatePlaceholderText={t('Начало')}
                        endDatePlaceholderText={t('Конец')}
                        isOutsideRange={this.isOutsideRange}
                        isDayBlocked={this.isDayBlocked}
                        isDayHighlighted={this.isDayHighlighted}
                        customCloseIcon={this.renderCloseIcon()}
                        renderMonthText={this.renderMonthText}
                        displayFormat={this.props.formats.date}
                    />
                    <div className={styles.spacer} />
                    <TotalBalance
                        currencyList={this.props.totalTransactionsSum}
                        isUpdating={this.props.isTotalTransactionsSumUpdating}
                    />
                </div>
                <div className={styles.tableWrapper}>
                    <div
                        className={styles.table}
                        onScroll={this.tableScroll}
                        ref={this.setTableRef}
                    >
                        {this.renderHistoryTable()}
                    </div>
                    <div
                        className={styles.shadowTop}
                        ref={(r) => {
                            if (r) {
                                this.shadowTop = r
                            }
                        }}
                    />
                    <div
                        className={styles.shadowBottom}
                        ref={(r) => {
                            if (r) {
                                this.shadowBottom = r
                            }
                        }}
                    />
                </div>
            </div >
        )
    }
}

export default History